// Règles d'affichage liées au marché (tenant), posées au boot de chaque app React.
// Défaut : marché espagnol, pour ne pas masquer le DNI/NIE si le flag n'est pas fourni.

let nationalIdRequired = true

export const configureMarketUi = ({ nationalIdRequired: required }: { nationalIdRequired?: boolean }): void => {
  if (typeof required === 'boolean') nationalIdRequired = required
}

export const marketRequiresNationalId = (): boolean => nationalIdRequired
